<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <Tooltip :open="tooltips['cruise-list-header-icon-schiff'].show"
             :position="tooltips['cruise-list-header-icon-schiff'].pos">
      <span class="tooltip-text">
        <span class="label d-inline-block fw-bold">BE</span>
        <span>AIDAbella</span>
        <br>
        <span class="label d-inline-block fw-bold">BL</span>
        <span>AIDAblu</span>
        <br>
        <span class="label d-inline-block fw-bold">CO</span>
        <span>AIDAcosma</span>
        <br>
        <span class="label d-inline-block fw-bold">DI</span>
        <span>AIDAdiva</span>
        <br>
        <span class="label d-inline-block fw-bold">LU</span>
        <span>AIDAluna</span>
        <br>
        <span class="label d-inline-block fw-bold">MA</span>
        <span>AIDAmar</span>
        <br>
        <span class="label d-inline-block fw-bold">NO</span>
        <span>AIDAnova</span>
        <br>
        <span class="label d-inline-block fw-bold">PE</span>
        <span>AIDAperla</span>
        <br>
        <span class="label d-inline-block fw-bold">PR</span>
        <span>AIDAprima</span>
        <br>
        <span class="label d-inline-block fw-bold">SO</span>
        <span>AIDAsol</span>
        <br>
        <span class="label d-inline-block fw-bold">ST</span>
        <span>AIDAstella</span>
        <br>
      </span>
    </Tooltip>

    <Tooltip :open="tooltips['cruise-list-header-icon-bett'].show"
             :position="tooltips['cruise-list-header-icon-bett'].pos">
      <span class="tooltip-text">
        <span class="label d-inline-block fw-bold">I</span>
        <span>Innenkabine</span>
        <br>
        <span class="label d-inline-block fw-bold">M</span>
        <span>Meerblickkabine</span>
        <br>
        <span class="label d-inline-block fw-bold">B</span>
        <span>Balkonkabine</span>
        <br>
        <span class="label d-inline-block fw-bold">V</span>
        <span>Verandakabine/Verandakabine Komfort/Deluxe</span>
        <br>
        <span class="label d-inline-block fw-bold">S</span>
        <span>Suite</span>
        <br>
        <div class="mt-2 fs-10">
          <span class="fw-bold">Hinweis:</span>
          <span>
            Angezeigt wird jeweils der günstigste verfügbare Ab-Preis pro Kategorie.
          </span>
        </div>
      </span>
    </Tooltip>

    <Tooltip :open="tooltips['cruise-list-header-icon-comfort-all-inclusive'].show"
             :position="tooltips['cruise-list-header-icon-comfort-all-inclusive'].pos">
      <span class="tooltip-text">
        <h1 class="fw-bold color-expinet-blue">{{ priceModelLabel('COMAI') }} Tarif</h1>

        <h2 class="fw-bold mt-2">Der {{ priceModelLabel('COMAI') }} Tarif<sup>*</sup> beinhaltet:</h2>

        <h2 class="fw-bold mt-3">Vor der Reise</h2>
        <ul class="ps-3">
          <li>Wahl der Wunschkabine (Innenkabinen nicht buchbar)</li>
          <li>Frühbucher-Bonus<sup>*</sup> </li>
          <li>VIP-Hotline ab Buchung bis Reisebeginn</li>
          <li>7 Tage unverbindliche Reservierung der Reise</li>
        </ul>

        <h2 class="fw-bold mt-3">An- &amp; Abreise</h2>
        <ul class="ps-3">
          <li>AIDA Rail&Fly Ticket 1. Klasse bei gebuchtem AIDA An- und Abreisepaket mit Flug</li>
          <li>Bei individueller Anreise: „Früher an Bord“ Check-in, Überholspur am Check-in</li>
        </ul>

        <h2 class="fw-bold mt-3">An Bord</h2>
        <ul class="ps-3">
          <li>Umfangreichstes Getränkepaket ALL IN (ab 25 Jahren), Kids & Teens ALL IN (2–24 Jahre)</li>
          <li>Täglich 2 Stunden Wellness Oase bzw. Organic Spa inkl. Sauna (ab 16 J.)</li>
          <li>Internet Flat inkl. Onboard Chat für die gesamte Reise</li>
          <li>2 Flaschen Mineralwasser in der Kabine (täglich aufgefüllt)</li>
          <li>Speisen in allen Buffet-Restaurants</li>
          <li>Speisen in allen Spezialitäten-Restaurants</li>
          <li>Alle AIDA Inklusivleistungen (tarifunabhängig)</li>
        </ul>

        <div class="fs-10 mt-4 ps-1"> <sup>*</sup> Limitiertes Kontingent </div>
      </span>
    </Tooltip>

    <Tooltip :open="tooltips['cruise-list-header-icon-premium'].show"
             :position="tooltips['cruise-list-header-icon-premium'].pos">
      <span class="tooltip-text">
        <h1 class="fw-bold color-expinet-blue">{{ priceModelLabel('IND') }} Tarif</h1>

        <h2 class="fw-bold mt-2">Der {{ priceModelLabel('IND') }} Tarif beinhaltet:</h2>

        <h2 class="fw-bold mt-3">Vor der Reise</h2>
        <ul class="ps-3">
          <li>Wahl der Wunschkabine</li>
          <li>Frühbucher-Bonus<sup>*</sup></li>
          <li>3 Tage unverbindliche Reservierung der Reise</li>
        </ul>

        <h2 class="fw-bold mt-3">An- &amp; Abreise</h2>
        <ul class="ps-3">
          <li>AIDA Rail&Fly Ticket 2. Klasse bei gebuchtem AIDA An- und Abreisepaket mit Flug</li>
        </ul>

        <h2 class="fw-bold mt-3">An Bord</h2>
        <ul class="ps-3">
          <li>Onboard Chat für die gesamte Reise</li>
          <li>2 Flaschen Mineralwasser in der Kabine (täglich aufgefüllt)</li>
          <li>Speisen in allen Buffet-Restaurants</li>
          <li>Speisen in allen Spezialitäten-Restaurants</li>
          <li>Ausgewählte Getränke in den Buffet-Restaurants inklusive</li>
          <li>Alle AIDA Inklusivleistungen (tarifunabhängig)</li>
        </ul>

        <div class="fs-10 mt-4 ps-1"> <sup>*</sup> Limitiertes Kontingent </div>
      </span>
    </Tooltip>

    <Tooltip :open="tooltips['cruise-list-header-icon-premium-all-inclusive'].show"
             :position="tooltips['cruise-list-header-icon-premium-all-inclusive'].pos">
      <span class="tooltip-text">
        <h1 class="fw-bold color-expinet-blue">{{ priceModelLabel('INDAI') }} Tarif</h1>

        <h2 class="fw-bold mt-2">Der {{ priceModelLabel('INDAI') }} Tarif beinhaltet:</h2>

        <h2 class="fw-bold mt-3">Vor der Reise</h2>
        <ul class="ps-3">
          <li>Wahl der Wunschkabine</li>
          <li>Frühbucher-Bonus<sup>*</sup></li>
          <li>3 Tage unverbindliche Reservierung der Reise</li>
        </ul>

        <h2 class="fw-bold mt-3">An- &amp; Abreise</h2>
        <ul class="ps-3">
          <li>AIDA Rail&Fly Ticket 2. Klasse bei gebuchtem AIDA An- und Abreisepaket mit Flug</li>
        </ul>

        <h2 class="fw-bold mt-3">An Bord</h2>
        <ul class="ps-3">
          <li>Umfangreichstes Getränkepaket ALL IN (ab 25 Jahren), Kids & Teens ALL IN (2–24 Jahre)</li>
          <li>Onboard Chat für die gesamte Reise</li>
          <li>2 Flaschen Mineralwasser in der Kabine (täglich aufgefüllt)</li>
          <li>Speisen in allen Buffet-Restaurants</li>
          <li>Speisen in allen Spezialitäten-Restaurants</li>
          <li>Alle AIDA Inklusivleistungen (tarifunabhängig)</li>
        </ul>

        <div class="fs-10 mt-4 ps-1"> <sup>*</sup> Limitiertes Kontingent </div>
      </span>
    </Tooltip>

    <Tooltip :open="tooltips['cruise-list-header-icon-classic'].show"
             :position="tooltips['cruise-list-header-icon-classic'].pos"
             orient="right">
      <span class="tooltip-text">
        <h1 class="fw-bold color-expinet-blue">{{ priceModelLabel('CLASSIC') }} Tarif</h1>
        <h2 class="fw-bold mt-2">Der {{ priceModelLabel('CLASSIC') }} Tarif beinhaltet:</h2>

        <h2 class="fw-bold mt-3">Vor der Reise</h2>
        <ul class="ps-3">
          <li>Wahl der Kabinenkategorie</li>
          <li>Unverbindliche Reservierung der Reise als Tagesoption</li>
        </ul>

        <h2 class="fw-bold mt-3">An Bord</h2>
        <ul class="ps-3">
          <li>Speisen in allen Buffet-Restaurants</li>
          <li>Speisen in allen Spezialitäten-Restaurants</li>
          <li>Ausgewählte Getränke in den Buffet-Restaurants inklusive</li>
          <li>Alle AIDA Inklusivleistungen (tarifunabhängig)</li>
        </ul>
      </span>
    </Tooltip>

    <Tooltip :open="tooltips['cruise-list-header-icon-classic-all-inclusive'].show"
             :position="tooltips['cruise-list-header-icon-classic-all-inclusive'].pos"
             orient="right">
      <span class="tooltip-text">
        <h1 class="fw-bold color-expinet-blue">{{ priceModelLabel('CLAAI') }} Tarif</h1>
        <h2 class="fw-bold mt-2">Der {{ priceModelLabel('CLAAI') }} Tarif beinhaltet:</h2>

        <h2 class="fw-bold mt-3">Vor der Reise</h2>
        <ul class="ps-3">
          <li>Wahl der Kabinenkategorie</li>
          <li>Unverbindliche Reservierung der Reise als Tagesoption</li>
        </ul>

        <h2 class="fw-bold mt-3">An Bord</h2>
        <ul class="ps-3">
          <li>Umfangreichstes Getränkepaket ALL IN (ab 25 Jahren), Kids & Teens ALL IN (2–24 Jahre)</li>
          <li>Speisen in allen Buffet-Restaurants</li>
          <li>Speisen in allen Spezialitäten-Restaurants</li>
          <li>Alle AIDA Inklusivleistungen (tarifunabhängig)</li>
        </ul>
      </span>
    </Tooltip>

    <Tooltip :open="tooltips['cruise-list-header-icon-specials'].show"
             :position="tooltips['cruise-list-header-icon-specials'].pos"
             orient="right">
      <span class="tooltip-text">
        <h1 class="fw-bold color-expinet-blue">{{ priceModelLabel('LIG') }}</h1>
        <h2 class="fw-bold mt-2">Der Tarif {{ priceModelLabel('LIG') }} beinhaltet:</h2>

        <h2 class="fw-bold mt-3">Vor der Reise</h2>
        <ul class="ps-3">
          <li>Wahl der Kabinenkategorie</li>
        </ul>

        <h2 class="fw-bold mt-3">An Bord</h2>
        <ul class="ps-3">
          <li>Speisen in allen Buffet-Restaurants</li>
          <li>Speisen in einigen Spezialitäten-Restaurants</li>
          <li>Ausgewählte Getränke in den Buffet-Restaurants inklusive</li>
          <li>Alle AIDA Inklusivleistungen (tarifunabhängig)</li>
        </ul>

        <hr>

        <h1 class="fw-bold color-expinet-blue">{{ priceModelLabel('PAUAI') }} oder {{ priceModelLabel('PAU') }}</h1>
        <h2 class="fw-bold mt-2">
          Der Sondertarif {{ priceModelLabel('PAUAI') }}<sup>*</sup> oder {{ priceModelLabel('PAU')
          }}<sup>*</sup> beinhaltet:
        </h2>

        <h2 class="fw-bold mt-3">Vor der Reise</h2>
        <ul class="ps-3">
          <li>Wahl der Kabinenkategorie</li>
        </ul>

        <h2 class="fw-bold mt-3">An- &amp; Abreise</h2>
        <ul class="ps-3">
          <li>Inkl. Flug bei Reisen mit internationalen Starthäfen</li>
        </ul>

        <h2 class="fw-bold mt-3">An Bord</h2>
        <ul class="ps-3">
          <li>PAUSCHAL ALL IN: Umfangreichstes Getränkepaket ALL IN (ab 25 Jahren), Kids & Teens ALL IN (2–24 Jahre)</li>
          <li>Speisen in allen Buffet-Restaurants</li>
          <li>Speisen in allen Spezialitäten-Restaurants</li>
          <li>Alle AIDA Inklusivleistungen (tarifunabhängig)</li>
        </ul>

        <div class="fs-10 mt-4 ps-1">
          <sup>*</sup> Sondertarif, basierend auf den Tarifkonditionen von CLASSIC ALL IN bzw. CLASSIC. Bei
          internationalem Start- und Zielhafen ist die Reise nur mit Flug buchbar.
        </div>
      </span>
    </Tooltip>
  </div>
</template>

<script lang="ts">
import { useUiStore } from '@/store'
import { mapPriceModelLabel } from '@/store/details/helper'
import { IbePriceModelCode } from '@gecko-akh/pkg-cruise-api-types/src/iris'
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import Tooltip from '../common/Tooltip.vue'

export default defineComponent({
  components: { Tooltip },

  computed: {
    ...mapState(useUiStore, {
      tooltips: store => store.tooltips,
    }),
  },

  methods: {
    priceModelLabel: (priceModel: string) => {
      return mapPriceModelLabel(priceModel as IbePriceModelCode)
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.tooltip-text {
  font-size: $default-font-size;
  font-weight: normal;

  >h1 {
    font-size: 16px;
    line-height: 20px;
    font-family: 'Open Sans';
  }

  >h2 {
    font-size: 12px;
    line-height: 20px;
    font-family: 'Open Sans';
  }
}

.label {
  font-size: $default-font-size;
  min-width: 25px;
}
</style>
